module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-texte__layout-wrapper"
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex",
    on: {
      "mousemove": _vm.dragMove,
      "mouseup": _vm.dragStop
    }
  }, [(_vm.cols == 3) ? _c('div', {
    ref: "sidebar-1",
    staticClass: "ksm_texte__layout-sidebar",
    style: (_vm.styleSidebar1)
  }, [_vm._t("sidebar-1")], 2) : _vm._e(), _vm._v(" "), (_vm.cols == 3) ? _c('div', {
    staticClass: "ksm-resizer-wrapper--left"
  }, [_c('div', {
    staticClass: "ksm-resizer",
    staticStyle: {
      "left": "0"
    },
    on: {
      "mousedown": function($event) {
        return _vm.dragStart($event, true)
      }
    }
  }, [_c('div', {
    staticClass: "__pointer",
    class: _vm.modus,
    domProps: {
      "innerHTML": _vm._s(_vm.$_getIcon(_vm.leftCollapse ? 'arrow-right-2.svg' : 'arrow-left-2.svg'))
    },
    on: {
      "click": _vm.setCollapseLeft
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "ksm-texte__layout--main"
  }, [_vm._t("main-content", function() {
    return [_vm._v("main slot in layout")]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "ksm-resizer-wrapper"
  }, [_c('div', {
    staticClass: "ksm-resizer",
    class: _vm.rightCollapse ? 'active' : '',
    on: {
      "mousedown": _vm.dragStart
    }
  }, [_c('div', {
    staticClass: "__pointer",
    class: _vm.modus,
    domProps: {
      "innerHTML": _vm._s(_vm.$_getIcon(_vm.rightCollapse ? 'arrow-left-2.svg' : 'arrow-right-2.svg'))
    },
    on: {
      "click": _vm.setCollapseRight
    }
  })])]), _vm._v(" "), _c('div', {
    ref: "sidebar-2",
    staticClass: "ksm_texte__layout-sidebar",
    style: (_vm.styleSidebar2)
  }, [_vm._t("sidebar-2")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2aa5b0ff","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SplitLayout.vue
// module id = 1962
// module chunks = 1